import AlertView from './AlertView';

export default AlertView;
